import { Component, OnInit, ViewChild, AfterViewInit, Output, EventEmitter, Input, ElementRef, SimpleChanges } from '@angular/core';
import { mtasModel } from './mtas.model';

// import { FileuploadComponent } from '../../../fileupload/fileupload.component';
import { DateComponent } from '../../../date/date.component';
import { ButtonComponent } from '../../../button/button.component';
import { AmountComponent } from '../../../amount/amount.component';
import { FormComponent } from '../../../form/form.component';
// import { ServiceStock } from '../../../service-stock.service';
import { LabelComponent } from '../../../label/label.component';
import { HttpResponse, HttpErrorResponse, HttpClient, HttpHeaders } from '@angular/common/http';
import { PasswordComponent } from '../../../password/password.component';
import { RadioButtonComponent } from '../../../radio-button/radio-button.component';
import { StockComponent } from '../../components/Stock/Stock.component';
import { ChartsComponent } from '../../components/Chart/Chart.component';
import { IndicatorComponent } from '../../components/Indicator/Indicator.component';
import { CONSTANTS } from 'src/app/constants.model';

import { ServiceStock } from 'src/app/service-stock.service';
import { ComboBoxComponent } from 'src/app/combo-box/combo-box.component';
import { ExchangeComponent } from '../../components/Exchange/Exchange.component';
import { BoardComponent } from '../../components/Board/Board.component';

import * as xml2js from 'xml2js';
import 'anychart';

const customCss: string = '';

@Component({
  selector: 'app-mtas',
  templateUrl: './mtas.component.html'
})
export class mtasComponent extends FormComponent implements OnInit, AfterViewInit {
  @ViewChild('FieldId_1', { static: false }) FieldId_1: ElementRef;
  @ViewChild('cmbStock', { static: false }) cmbStock: StockComponent;
  @ViewChild('dtFromDate', { static: false }) dtFromDate: DateComponent;
  @ViewChild('dtTodate', { static: false }) dtTodate: DateComponent;
  @ViewChild('cstmChart', { static: false }) cstmChart: ChartsComponent;
  @ViewChild('cstmIndicator', { static: false }) cstmIndicator: IndicatorComponent;
  @ViewChild('btnSubmit', { static: false }) btnSubmit: ButtonComponent;
  @ViewChild('btnReset', { static: false }) btnReset: ButtonComponent;
  @ViewChild('FieldId_3', { static: false }) FieldId_3: ElementRef;
  @ViewChild('cmbMtasChart', {static: false}) cmbMtasChart: ComboBoxComponent;
  @ViewChild('cstmExchange', { static: false }) cstmExchange: ExchangeComponent;
  @ViewChild('cstmBoard', { static: false }) cstmBoard: BoardComponent;
  @ViewChild('chartContainer', { static: false }) container: any;
  @Output() chartSelected: EventEmitter<any> = new EventEmitter<any>();

  @ViewChild('fillColor', { static: false }) fillColor: ElementRef;
  @ViewChild('strokeColor', { static: false }) strokeColor: ElementRef;
  @ViewChild('drawSelect', { static: false }) drawSelect: ComboBoxComponent; // ElementRef;
  @ViewChild('strokeSize', { static: false }) strokeSize: ComboBoxComponent; // ElementRef;
  @ViewChild('strokeDash', { static: false }) strokeDash: ComboBoxComponent; // ElementRef;
  @ViewChild('markerType', { static: false }) markerType: ComboBoxComponent; // ElementRef;
  @ViewChild('markerSize', { static: false }) markerSize: ComboBoxComponent; // ElementRef;
  // @ViewChild('jqxDropDownList', {static: false}) jqxDropDownList: ComboBoxComponent;
  @ViewChild('fontColor', { static: false }) fontColor: ElementRef;
  @ViewChild('fontSize', { static: false }) fontSize: ComboBoxComponent;

  mtasRequestObject: any = {};
  exchangeSelected: any;
  productSelected: any;
  stockFilterSelected: string = CONSTANTS.EMPTY_STRING;
  exchangeList: any;
  productList: any;
  dataSource = [];
  dataTable: any;
  chartType: 'line' | 'bar' | 'stock' | 'index' | 'indexdetails' = "line"; 
  title: string = "Title";
  height: string = '100%';
  chart: any = null;
  table: any
  mapping: any
  chartdrawSelected: string = "";
  chartTypeList: any;
  indicatordrawSelected: string = "";
  indicatorTypeList: any;
  plot: any;
  annotationTypeList: any;
  annotationdrawSelected: string = "";
  strokeWidth: any;
  strokeWidthSelected: string = "";
  strokeTypeSelected: string = "";
  strokeWidthList: any;
  strokeType: any;
  strokedrawSelected: string = "";
  strokeTypeList: any;
  //indicatorsSettings: any;
  indicatorName: any;
  description: any;
  option: any;
  indicatorCheck: boolean = false;
  displayTools: boolean = true;
  private indicatorsSettings = new Map();
  private indicatorCache = new Map();
  private _selectedStock = CONSTANTS.ANNOUNCEMENT_SELECTED_STOCK;
  skeletonContentLoaded = false;
  MAX_INDICATOR: number = 3;
  SelectedIndicator: String = ""; // text for the Indicator dropdown
  SelectedIndicatorList = [];
  alertMessage: string = ""; // label to show errors related to Indicator
  productSelectedStock = this.services.dataStore.getproductMasterData();


  // for TESTING
  dataDB = [
    ["2018-08-20", 23.55, 23.88, 23.38, 23.62],
    ["2018-08-21", 22.65, 23.7, 22.65, 23.36],
    ["2018-08-22", 22.75, 23.7, 22.69, 23.44],
    ["2018-08-23", 23.2, 23.39, 22.87, 22.92],
    ["2018-08-24", 23.98, 24.49, 23.47, 23.49],
    ["2018-08-25", 23.55, 23.88, 23.38, 23.62],
    ["2018-08-26", 23.88, 23.93, 23.24, 23.25],
    ["2018-08-27", 23.17, 23.4, 22.85, 23.25],
    ["2018-08-28", 22.65, 23.7, 22.65, 23.36],
    ["2018-08-29", 23.2, 23.39, 22.87, 22.92],
    ["2018-08-30", 23.03, 23.15, 22.44, 22.97],
    ["2018-08-19", 22.75, 23.7, 22.69, 23.44],
    ];
  // data from server
  // dataDB = [
  //   ['2015-01-01', '30.0', '31.0', '30.0', '30.8', '3110752.1', '101081'],
  //   ['2015-01-05', '30.8', '31.0', '30.1', '30.5', '1033616.4', '34061']
  // ];
  // for TESTING
  
  async revalidate(): Promise<number> {
    var totalErrors = 0;
    // super.beforeRevalidate();
    await Promise.all([
      // this.revalidateBasicField('dtFromDate', false, 'dtTodate'),
      // this.revalidateBasicField('dtTodate', false, 'dtFromDate'),
      // this.revalidateBasicField('cmbMtasChart'),
      // this.cstmChart.revalidate(),
      // this.cstmIndicator.revalidate(),
      this.validateSymbol(),
      this.validateDate(), this.validateDateRange(),
      this.validateOtherInputs()
    ]).then((errorCounts) => {
      errorCounts.forEach((errorCount) => {
        totalErrors += errorCount;
      });
    });
    this.errors = totalErrors;
    // super.afterRevalidate();
    return totalErrors;
  }

  constructor(services: ServiceStock, private _http: HttpClient) {
    super(services);
    // this.value = new mtasModel();
    // this.componentCode = 'mtas';
    anychart.licenseKey("intellectdesign-d34a0ad1-63e85597");
    anychart.format.locales.default.numberLocale.decimalsCount = 2;
    anychart.format.locales.default.numberLocale.zeroFillDecimals = true;
    anychart.format.locales.default.numberLocale.groupsSeparator = ',';
  }

  setReadOnly(readOnly) {
    super.setBasicFieldsReadOnly(readOnly);
    // this.cstmChart.setReadOnly(readOnly);
    this.cstmIndicator.setReadOnly(readOnly);
  }

  async onFormLoad() {
    this.setInputs(this.services.dataStore.getData(this.services.routing.currModal));
    
    this.cmbMtasChart.setValue("ohlc");
    this.dtFromDate.setValue(new Date());
    this.dtTodate.setValue(new Date());
    // this.strokeSize.setValue("1");
    // this.strokeDash.setValue("6");
    // this.markerType.setValue("arrowUp");
    // this.markerSize.setValue("5");
    // this.fontSize.setValue("15");

    this.setDependencies();
    this.reloadStock();
    // this.drawChart();  // blank chart
  }

  setInputs(param: any) {
    let params = this.services.http.mapToJson(param);
    if (params['mode']) {
      this.mode = params['mode'];
    }
  }

  async submitForm(path, apiCode, serviceCode) {
    this.submitData['formName'] = 'mtas';
    await super.submit(path, apiCode, serviceCode);
  }

  getFieldInfo() {
    this.amountComponent.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    this.comboFields.forEach(field => { this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo(); });
    // this.fileUploadFields.forEach(field => {this.additionalInfo[field.fieldID + '_desc'] = field.getFieldInfo();});
    // this.additionalInfo['cstmChart_desc'] = this.cstmChart.getFieldInfo();
    this.additionalInfo['cstmIndicator_desc'] = this.cstmIndicator.getFieldInfo();
    return this.additionalInfo;
  }

  getFieldValue() {
    // this.value.cstmChart = this.cstmChart.getFieldValue();
    this.value.cstmIndicator = this.cstmIndicator.getFieldValue();
    return this.value;
  }

  setValue(inputValue, inputDesc = undefined) {
    this.setBasicFieldsValue(inputValue, inputDesc);
    // this.cstmChart.setValue(inputValue['cstmChart'], inputDesc['cstmChart_desc']);
    this.cstmIndicator.setValue(inputValue['cstmIndicator'], inputDesc['cstmIndicator_desc']);
    this.value = new mtasModel();
    this.value.setValue(inputValue);
    this.setDependencies();
    this.passNewValue(this.value);
  }
  setProductField(value: string): void {
    this.productSelectedStock = value;
  }


  ngOnInit() {
    if (this.formCode == undefined) { this.formCode = 'mtas'; }
    if (this.formOnLoadError) { return; }
    setTimeout(() => {
      this.skeletonContentLoaded = true;
    }, 1000);
    var styleElement = document.createElement('style');
    styleElement.type = 'text/css';
    styleElement.innerHTML = customCss;
    styleElement.id = 'mtas_customCss';
    document.getElementsByTagName('head')[0].appendChild(styleElement);

    this.SelectedIndicator = this.services.transalte('Indicator.cmbIndicator_FP_placeholder');
    this.SelectedIndicatorList = [];
    
    // if (this.chart) {
    //   this.chart.dispose();
    // }
    this.removeChart();
    this.setProductField(this.productSelectedStock);

    // create a chart
    if (this.chartType == "line") {
      this.chart = anychart.line();
    } else if (this.chartType == "bar") {
      this.chart = anychart.column();
    } else if (this.chartType == "index") {
      this.chart = anychart.line();
      this.chart.xAxis(false);
      this.chart.yAxis(false);
    } else if (this.chartType == "indexdetails") {
      this.chart = anychart.line();
    } else {
      this.chart = anychart.stock(true);
    }

    this.chart.credits().enabled(false);
    this.chart.title(this.title);
    this.chart.tooltip(false);
    this.chart.interactivity().selectionMode("none");
    this.chart.yAxis().labels().position("inside");

    let series = null;
    if (this.chartType == "line") {
      series = this.chart.spline(this.dataSource);
    } else if (this.chartType == "bar") {
      series = this.chart.column(this.dataSource);
    } else if (this.chartType == "index") {
      series = this.chart.spline(this.dataSource);
    } else if (this.chartType == "indexdetails") {
      series = this.chart.spline(this.dataSource);
    } else {
      this.plot = this.chart.plot(0);
      this.plot.candlestick(this.dataSource);
    }

    if (series) {
      series.markers().enabled(false);
      series.hovered().markers().enabled(false);
    }
    if (this.container) {
      this.chart.container(this.container.nativeElement);
      this.chart.draw();
    }
  }
  
  ngOnDestroy() {
    this.unsubscribe$.next();
    this.unsubscribe$.complete();
    var styleElement = document.getElementById('mtas_customCss');
    styleElement.parentNode.removeChild(styleElement);
  }

  ngAfterViewInit() {
    setTimeout(() => {
      // this.subsBFldsValueUpdates();
      this.chartTypeList = this.services.dataStore.getChartList();
      this.chartdrawSelected = this.chartTypeList[0].text;
      // this.value.cstmChart = this.cstmChart.getFieldValue();
      // this.cstmChart.valueChangeUpdates().subscribe((value) => {this.value.cstmChart = value;});
      // this.value.cstmIndicator = this.cstmIndicator.getFieldValue();
      // this.cstmIndicator.valueChangeUpdates().subscribe((value) => {this.value.cstmIndicator = value;});
      
      this.loadXML();
      this.onFormLoad();     
      this.checkForHTabOverFlow();
    });
  }
  clearError() {
    super.clearBasicFieldsError();
    super.clearHTabErrors();
    super.clearVTabErrors();
    this.cmbMtasChart.clearError();
    this.cstmChart.clearError();
    this.cstmIndicator.clearError();
    this.errors = 0;
    this.errorMessage = [];
  }
  onReset() {
    super.resetBasicFields();
    this.cstmChart.onReset();
    this.cstmIndicator.onReset();
    this.clearHTabErrors();
    this.clearVTabErrors();
    this.errors = 0;
    this.errorMessage = [];
    this.additionalInfo = undefined;
    this.dependencyMap.clear();
    this.value = new mtasModel();
    this.passNewValue(this.value);
    this.setReadOnly(false);
    this.onFormLoad();
  }
  async cmbStock_stockSelected(event) {
    let inputMap = new Map();
  }
  async cstmProduct_productSelected(event) {
    let inputMap = new Map();
    this.reloadStock();
}
  async cstmChart_chartSelected(event) {
    let inputMap = new Map();
  }
  async cstmIndicator_indicatorSelected(event) {
    let inputMap = new Map();
  }
  async btnSubmit_click(event) {
    this.alertMessage = "";
    let inputMap = new Map();
    var errorCount: number = await this.revalidate();
    if (errorCount == 0) {
      inputMap.clear();
      this.removeChart();
      // Clear Any Selected/Checked Indicators
      var indicatorChecked = document.getElementsByClassName('indicatorChecked');
      for (var i: number = 0; i < indicatorChecked.length; i++){
        (indicatorChecked[i] as HTMLInputElement).checked = false
      }
      this.SelectedIndicator = this.services.transalte('Indicator.cmbIndicator_FP_placeholder');
      this.SelectedIndicatorList = [];
      
      // inputMap.set('Body.symbol', this.stockCombo.this.stockCombo.gotxComboBox.getSelectedItem().value.stockCombo.gotxComboBox.getSelectedItem().valuegetSelectedItem().value);
      inputMap.set('Body.lastDate', this.services.dataStore.dateToInt(this.services.dataStore.dateToDateString(this.dtTodate.getFieldValue())));
      inputMap.set('Body.startDate', this.services.dataStore.dateToInt(this.services.dataStore.dateToDateString(this.dtFromDate.getFieldValue())));
      inputMap.set('Body.deviceType', "AW");
      inputMap.set('Body.indiSessionInfo', true);
      inputMap.set('Body.intervalCount', 0);
      inputMap.set('Body.periodType', "D");
      inputMap.set('Body.reqType', "OHLCHIST");
      inputMap.set('Body.useSessionValues', true);
      inputMap.set('Body.product', 14);
      inputMap.set('Body.exchange', "CTG");
      inputMap.set('Body.sendResponseFormat', "JSON");
      inputMap.set('Body.intervalType', "D");

      if (typeof this.cmbStock.gotxInput.val() === 'object') {
        inputMap.set('Body.symbol', this.cmbStock.gotxInput.val().label);
      }
      else {
        inputMap.set('Body.symbol', this.cmbStock.gotxInput.val());
      }

      // for TESTING
      // this.dataSource = this.dataDB;
      // this.title = 'TEST DATA';
      // if(this.dataSource.length != 0) { this.drawChart(); }
      // for TESTING

      this.services.http.fetchApi('/historicalData', 'POST', inputMap).subscribe(
        async (httpResponse: HttpResponse<any>) => {
          var res = httpResponse.body;
          var respCode: any = res['respCode'];
          if (respCode != null && respCode != 0) {
            //document.getElementById('errMsgDiv').innerHTML = res['errMsg'];
	    //commented by Shanmuga Priya - VAPT
            const rawMsg = res['errMsg'];
            const plainMsg = rawMsg.replace(/<[^>]*>/g, ""); // remove HTML tags
            (document.getElementById('errMsgDiv') as HTMLElement).textContent = plainMsg;
          }
          else {
            // plot data
            if (res.response.arrayResp) {  // res['response'].arrayResp
              this.title = res.response.jsonResp.symbol;
              this.dataSource = res.response.arrayResp;
              if(this.dataSource.length != 0) { this.drawChart(); }
            } else {
            }
          }
        },
        async (httpError) => {
          var err = httpError['error']
          if (err != null && err['ErrorElementPath'] != undefined && err['ErrorDescription'] != undefined) {
          }
          this.services.alert.showAlert(2, "error part", -1);
        }
      );
    }
  }
  reloadStock() {
    this.cmbStock.gotxInput.val("");
    // let exch = this.cstmExchange.cmbExchange.getFieldValue();
    let pdct = this.services.dataStore.getData("productID");
    if (typeof pdct == 'object' ){
      pdct = pdct.text
  }
  if(pdct == "EQUITY MARKET"){
      pdct = "EQUITY";
    }
    // let board = this.cstmBoard.cmbBoard.getFieldValue();
    this.cmbStock.source = this.services.dataStore.getcmbStockInput(this.cmbStock.searchMode, "CTG", pdct, "AL");
  }
  ngOnChanges(changes: SimpleChanges): void {
    if(this.dataSource.length != 0) { this.drawChart(); } // this.drawChart();
  }

  protected drawChart() {
    this.dataTable = anychart.data.table();
    this.mapping = this.dataTable.mapAs({
      'value': 1,
      'volume': 1,
      'open': 1,
      'high': 2,
      'low': 3,
      'close': 4
    });
    this.chart = anychart.stock();
    this.chart.credits().enabled(false);
    this.chart.plot(0).ohlc(this.mapping);
    this.table = anychart.data.table();
    this.table.addData(this.dataSource);

    // mapping the data
    this.mapping = this.table.mapAs();
    this.mapping.addField('open', 1, 'first');
    this.mapping.addField('high', 2, 'max');
    this.mapping.addField('low', 3, 'min');
    this.mapping.addField('close', 4, 'last');
    this.mapping.addField('value', 4, 'last');

    // defining the chart type
    this.chart = anychart.stock();
    this.chart.credits().enabled(false);
    // set the series type
    this.chart.plot(0).ohlc(this.mapping).name(this.title);  // 'ACME Corp.'

    // setting the chart title
    // this.chart.title('MTAS CHART');

    // display the chart
    this.chart.container('container');
    this.chart.draw();
  }

  protected chartTypeChanged($event: any) {
    this.chartdrawSelected = $event.target.value;
    this.chart.plot().getSeries(0).seriesType(this.chartdrawSelected);
  }

  protected indicatorTypeChanged($event: any, indicator: any) {
    this.alertMessage = "";
    if(this.dataSource.length == 0) {
      $event.target.checked = false;
      // this.services.MessageBox.showAlert(this.services.translate('mtas.maxIndicator'));
      // this.services.alert.showAlert(2, "mtas.errorSeries", -1);
      // this.alertMessage = this.services.transalte('Chart.NullChart'); // alert('Chart Not Plotted');
      this.flashMessage(this.services.transalte('Chart.NullChart'));
      return;
    }    

    if ($event.target.checked == false) {
      this.resetIndicators($event, indicator);
      return;
    }
    
    if(this.chart.getPlotsCount() > this.MAX_INDICATOR) {
      $event.target.checked = false;
      // this.services.MessageBox.showAlert(this.services.translate('mtas.maxIndicator'));
      // this.services.alert.showAlert(2, "mtas.maxIndicator", -1);
      // this.alertMessage = this.services.transalte('Chart.Max3IndAllow'); // alert('Maximum 3 Indicators are allowed');
      this.flashMessage(this.services.transalte('Chart.Max3IndAllow'));
      return;
    }
    
    try {
      this.indicatorCache.set(indicator.name, indicator);
      var plot = this.chart.plot(this.chart.getPlotsCount() + 1);    
      plot[indicator.value](this.mapping, indicator.seriesType);

      this.SelectedIndicatorList.push(indicator.abbreviation);
      this.SelectedIndicator = this.SelectedIndicatorList.join(', ');
    } catch (error) {
      $event.target.checked = false;
      this.resetIndicators($event, indicator);

      // this.alertMessage = this.services.transalte('Chart.IndPlotErr') + indicator.name; // alert('An error occurred while ploting the indicator ' + indicator.name);
      this.flashMessage(this.services.transalte('Chart.IndPlotErr') + indicator.name);
    }
  }
  protected drawIndicators() {
    this.indicatorCache.forEach((indicator, key) => {
      var plot = this.chart.plot(this.chart.getPlotsCount() + 1);
      plot[indicator.value](this.mapping, indicator.seriesType);
    });
  }

  protected resetIndicators($event: any, indicator: any) {
    if (this.indicatorCache.has(indicator.name)) {
      this.indicatorCache.delete(indicator.name);
      this.removeChart();
      this.drawChart();
      this.drawIndicators();
    }

    var index = this.SelectedIndicatorList.indexOf(indicator.abbreviation);
    if (index >= 0) {
      this.SelectedIndicatorList.splice( index, 1 );
    }
    if (this.SelectedIndicatorList.length == 0) {
      this.SelectedIndicator = this.services.transalte('Indicator.cmbIndicator_FP_placeholder');
      this.SelectedIndicatorList = [];
    } else {
      this.SelectedIndicator = this.SelectedIndicatorList.join(', ');
    }
  }

  // not server accessible '/assets/indicators.xml'
  // server accessible '/portal/assets/indicators.xml'
  loadXML() {
    this._http.get('/portal/assets/indicators.xml',
      {
        headers: new HttpHeaders()
          .set('Content-Type', 'text/xml')
          .append('Access-Control-Allow-Methods', 'GET')
          .append('Access-Control-Allow-Origin', '*')
          .append('Access-Control-Allow-Headers', "Access-Control-Allow-Headers, Access-Control-Allow-Origin, Access-Control-Request-Method"),
        responseType: 'text'
      })
      .subscribe((data) => {
        this.parseXML(data)
          .then((data: any) => {
            this.indicatorTypeList = data;
            this.indicatordrawSelected = data[0].text;
          });
      });
  }
  private parseXML(data: any) {
    return new Promise(resolve => {
      var k: string | number,
        arr = [],

        parser = new xml2js.Parser(
          {
            trim: true,
            explicitArray: true
          });

      parser.parseString(data, (err, result) => {
        var obj = result.indicators["indicator"];
        var arr = [];

        obj.forEach(element => {
          var _indicatorSettings = {
            text: '',
            name: '',
            value: '',
            selected: false,
            plotIndex: 0,
            defaultSettings: {},
            seriesType: [
              'area',
              'column',
              'jumpLine',
              'line',
              'marker',
              'spline',
              'splineArea',
              'stepArea',
              'stepLine',
              'stick'
            ]
          };

          _indicatorSettings.text = element.title[0];
          _indicatorSettings.name = element['$'].type;
          _indicatorSettings.value = element['$'].type;
          _indicatorSettings['abbreviation'] = element.abbreviation[0];
          _indicatorSettings['description'] = element.description[0];

          let _defaults = '';

          element.defaults[0].item.forEach(e => {
            if (e['$'].name == "plotIndex") {
              _indicatorSettings.plotIndex = e['$'].value;
            }
            else {
              _defaults += e['$'].value + ',';
            }
          });
          _indicatorSettings.defaultSettings = _defaults;

          this.indicatorsSettings.set(element['$'].type, _indicatorSettings);

          arr.push(_indicatorSettings);
        });
        resolve(arr);
      });
    });
  }

  protected removeChart() {
    if (this.chart) {
      this.chart.dispose();
      this.chart = null;
    }
  }
  
  protected annotationTypeChanged($event: any) {
    this.annotationdrawSelected = $event.text;
    this.create($event);
  }

  protected create(ev) {
    var select = ev.value;
    this.plot = this.chart.plot(0);
    this.plot.annotations().startDrawing(select);
  }

  protected resetMtasChart() {
    this.alertMessage = "";
    this.displayTools = true;
    this.indicatorCache.clear();

    // Clear Any Selected/Checked Indicators
    var indicatorChecked = document.getElementsByClassName('indicatorChecked');
    for (var i: number = 0; i < indicatorChecked.length; i++){
      (indicatorChecked[i] as HTMLInputElement).checked = false
    }
    this.SelectedIndicator = this.services.transalte('Indicator.cmbIndicator_FP_placeholder');
    this.SelectedIndicatorList = [];

    // Clear Any Selected ComboBoxes
    // this.cmbStock.gotxInput.val("");
    this.cmbMtasChart.setValue("ohlc");
    this.drawSelect.setValue(null);
    this.markerType.setValue(null);
    this.markerSize.setValue(null);
    this.strokeSize.setValue(null);
    this.strokeDash.setValue(null);

    this.removeChart();
    if(this.dataSource.length != 0) { this.drawChart(); }
    this.plot.annotations().removeAllAnnotations();
  }

  protected stockSelected(ev: any) {
    if (!ev) {
      this._selectedStock = CONSTANTS.ANNOUNCEMENT_SELECTED_STOCK;
    }
    else {
      this._selectedStock = ev.dispSymbol;
      this.mtasRequestObject["symbol"] = this._selectedStock;
    }
  }

  protected createDrawing(item?: String) {
    // console.log(this.drawSelect.nativeElement.value + ' | ' + item);
    // console.log((document.getElementById('drawSelect') as HTMLInputElement).value);
    if (item != null) {
      this.chart.annotations().startDrawing(item);
    } else {
      // this.chart.annotations().startDrawing(this.drawSelect.nativeElement.value);
      this.chart.annotations().startDrawing(this.drawSelect.getFieldValue());
    }
  }

  protected createMarker() {
    // console.log((document.getElementById('markerType') as HTMLInputElement).value);
    
    // keep it updated 'markerType'
    var marker = {
      arrowUp:'top',
      arrowDown:'bottom',
      arrowLeft:'left',
      arrowRight:'right',
      arrowHead:'right',
      cross:'center',
      diagonalCross:'center',
      diamond:'center',
      pentagon:'center',
      square:'center',
      star10:'center',
      star4:'center',
      star5:'center',
      star6:'center',
      star7:'center',
      trapezium:'center',
      triangleUp:'top',
      triangleDown:'bottom',
      triangleLeft:'left',
      triangleRight:'right'
    }
    var type = 'marker';
    var markerType = this.markerType.getFieldValue(); // this.markerType.nativeElement.value;
    var markerSize = this.markerSize.getFieldValue(); // this.markerSize.nativeElement.value;
    var markerAnchor = marker[markerType];

    if (markerType == null) markerType = 'arrowUp';
    if (markerSize == null) markerSize = '10';
    
    var drawingSettings = {
      type: type,
      size: markerSize,
      markerType: markerType,
      anchor: markerAnchor  // ,
      // fontSize: fontSize,
	    // fontColor: fontColor
    };
    this.chart.annotations().startDrawing(drawingSettings);
  }

  protected createMarkerSize() {
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation == null) return;

    var markerType = this.markerType.getFieldValue(); // this.markerType.nativeElement.value;
    var markerSize = this.markerSize.getFieldValue(); // this.markerSize.nativeElement.value;

    if (markerType == null) markerType = 'arrowUp';
    if (markerSize == null) markerSize = '10';

    if (annotation.type === 'marker') {
      annotation.size(this.markerSize.getFieldValue());
    }
  }

  protected removeSelectedDrawing() {
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation) this.chart.annotations().removeAnnotation(annotation);
  }

  protected removeDrawings() {
    this.chart.annotations().removeAllAnnotations();
  }

  protected unSelectedAnnotation() {
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation) this.chart.annotations().unselect(annotation).cancelDrawing();
  }

  protected validateSymbol() {
    var totalErrors = 0;
    var value: any;

    if (typeof this.cmbStock.gotxInput.val() === 'object') {
      value =  this.cmbStock.gotxInput.val().label;
    }
    else {
      value = this.cmbStock.gotxInput.val();
    }

    if (value == undefined || value.toString() == '' || value.length == 0) {
      this['cmbStock'].setError("Value cannot be empty");
      return ++totalErrors;
    }
    return totalErrors;
  }

  protected validateDate() {
    var totalErrors = 0;
    var datePattern = "^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/[0-9]{4}$";

    if (!(this['dtFromDate'].getFieldValue().toString().match(datePattern))) {
      this['dtFromDate'].setError("Date should be of format DD/MM/YYYY");
      return ++totalErrors;
    }
    if (!(this['dtTodate'].getFieldValue().toString().match(datePattern))) {
      this['dtTodate'].setError("Date should be of format DD/MM/YYYY");
      return ++totalErrors;
    }
    return totalErrors;
  }

  protected validateDateRange() {
    var totalErrors = 0;
    let from = this.services.dataStore.dateStringToDate(this['dtFromDate'].getFieldValue().toString());
    let to = this.services.dataStore.dateStringToDate(this['dtTodate'].getFieldValue().toString());
    if (from > to) {
      this['dtFromDate'].setError("From should be lesser");
      return ++totalErrors;
    }
    return totalErrors;
  }

  protected validateOtherInputs() {
    var totalErrors = 0;
    // var datePattern = "^(0[1-9]|[12][0-9]|3[01])\/(0[1-9]|1[012])\/[0-9]{4}$";
    var value: any;

    // value = (document.getElementById('cmbIndicator') as HTMLInputElement).value;
    // if (value == undefined || value.toString() == '' || value.length == 0) {
    //   this['cmbIndicator'].setError("Value cannot be empty");
    //   return ++totalErrors;
    // }

    value = this['cmbMtasChart'].value;
    if (value == undefined || value.toString() == '' || value.length == 0) {
      this['cmbMtasChart'].setError("Value cannot be empty");
      return ++totalErrors;
    }
    return totalErrors;
  }

  protected changeFillColor() {
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation == null) return;

    annotation.color(this.fillColor.nativeElement.value);
  }

  protected changeStrokeColor() {
    var STROKE_WIDTH = 1;
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation == null) return;

    var strokeWidth = annotation.stroke().thickness || STROKE_WIDTH;
    var strokeDash = annotation.stroke().dash || '';
    var settings = {
        thickness: strokeWidth,
        color: this.strokeColor.nativeElement.value,
        dash: strokeDash
    };
    annotation.stroke(settings);
    annotation.hovered().stroke(settings);
    annotation.selected().stroke(settings);
  }

  protected strokeWidthChanged($event: any) {
    var STROKE_WIDTH = 1;
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation == null) return;

    var strokeWidth = this.strokeSize.getFieldValue() || STROKE_WIDTH;
    var strokeDash = annotation.stroke().dash || '';
    // if(strokeWidth == null) return;

    this.updatePropertiesBySelectedAnnotation(strokeWidth, strokeDash);
  }

  protected strokeTypeChanged($event: any) {
    var STROKE_WIDTH = 1;
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation == null) return;

    var strokeWidth = annotation.stroke().thickness || STROKE_WIDTH;
    var strokeDash = this.strokeDash.getFieldValue() || '';
    // if(strokeDash == null) return;

    this.updatePropertiesBySelectedAnnotation(strokeWidth, strokeDash);
  }

  protected updatePropertiesBySelectedAnnotation(strokeWidth, strokeType) {
    var strokeColor;
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation == null) return;

    if (typeof annotation.stroke() === 'function') {
      strokeColor = annotation.color();
    } else {
      strokeColor = annotation.stroke().color;
    }

    switch (strokeType) {
      case '6':
        strokeType = null;
        break;
      case '7':
        strokeType = '1 1';
        break;
      case '8':
        strokeType = '10 5';
        break;
    }
    var settings = {
      thickness: strokeWidth,
      color: strokeColor,
      dash: strokeType
    };

    annotation.stroke(settings);
    annotation.hovered(settings);
    annotation.selected(settings);
  }

  protected drawText() {
    var annotation = this.chart.annotations();
    if (annotation == null) return;

    var strokeSettings = {
      thickness: this.strokeSize.getFieldValue(),
      color: this.strokeColor.nativeElement.value,
      dash: this.strokeDash.getFieldValue()
    };

    var fontSettings = {
      hAlign:'center',
      vAlign:'middle',
      anchor:'center',

      type: 'label',
      size: this.fontSize.getFieldValue() || 15,
      // markerType: markerType,
      // anchor: 'center',
      fontSize: this.fontSize.getFieldValue() || 15,
      fontColor: this.fontColor.nativeElement.value,

      background: {
        fill: this.fillColor.nativeElement.value,
        stroke: strokeSettings
      },
      hovered: {
        fill: this.fillColor.nativeElement.value,
        stroke: strokeSettings
      },
      selected: {
        fill: this.fillColor.nativeElement.value,
        stroke: strokeSettings
      }
    };

    this.chart.annotations().startDrawing(fontSettings);
  }

  protected resetText() {
    var annotation = this.chart.annotations().getSelectedAnnotation();
    if (annotation == null) return;

    if (annotation && annotation.type === 'label') {
      annotation.width(null);
      annotation.height(null);
    }
  }

  protected flashMessage(message) {
    this.alertMessage = message;
    setTimeout(() => {
        if (this.alertMessage) this.alertMessage = "";
    }, 3000);
  }

  protected changeText() {
    
  }

  protected createPageColorPicker() {
    // ... need help
  }

}